export default __webpack_public_path__ + "static/media/eustace-new-crop.976f242c.jpg";